module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.71d0a8e1.eot";